var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwiftBranco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 669.415,
    height: 158.419,
    viewBox: "0 0 669.415 158.419",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "swift-branco",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8",
    "data-name": "Caminho 8",
    d: "M507.093,20.8A18.349,18.349,0,1,1,488.744,2.453,18.349,18.349,0,0,1,507.093,20.8",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9",
    "data-name": "Caminho 9",
    d: "M369.439,91.826l-27.18,66.159H313.5a7.664,7.664,0,0,1-7.636-6.992l-8.707-103.9h20.815A12.041,12.041,0,0,1,330.01,58.93l5.607,63.222,30.7-75.059h13.8a12.04,12.04,0,0,1,12.032,11.6l2.328,63.04,30.745-74.636h13.552a12.04,12.04,0,0,1,10.862,17.234l-38.513,93.658H379.392a7.664,7.664,0,0,1-7.659-7.384Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10",
    "data-name": "Caminho 10",
    d: "M467.965,47.094h19.1A12.04,12.04,0,0,1,498.88,61.439l-18.829,96.547h-24.41a7.664,7.664,0,0,1-7.522-9.131Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11",
    "data-name": "Caminho 11",
    d: "M587.888,47.094l-4.6,11.984A22.634,22.634,0,0,1,562.155,73.6H549.086L532.76,157.986H509.906a8.942,8.942,0,0,1-8.776-10.657L520.674,47.306a82.413,82.413,0,0,1,7.209-22.366,43.067,43.067,0,0,1,11.768-14.526,44.771,44.771,0,0,1,16.963-7.949C563.186.841,570.853.159,579.619.023c4.838-.075,9.9.048,14,.206a6.223,6.223,0,0,1,5.6,8.36l-6.664,18.364q-3.608-.207-7-.321t-6.148-.1a57.462,57.462,0,0,0-10.708.846,15.3,15.3,0,0,0-7.1,3.18,16.56,16.56,0,0,0-4.453,6.359,47.226,47.226,0,0,0-2.756,10.179Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_12",
    "data-name": "Caminho 12",
    d: "M635.8,47.094l5.234-25.654A16.452,16.452,0,0,0,624.772,2.155L611.137,2.2,588.844,113.46q-.636,3.61-1.06,6.994a51.1,51.1,0,0,0-.425,6.365q0,14.84,8.588,23.109T623.4,158.2c1.412,0,17.451-.028,17.451-.028a8.946,8.946,0,0,0,8.643-6.483l-.014,0,7-20.21c-.709,0-2.014.04-3.923.108s-4.028.109-6.36.109H634.642q-7.211,0-10.071-2.545t-2.863-7.634a31.357,31.357,0,0,1,.849-7.212L630.4,73.6h13.281a22.635,22.635,0,0,0,21.131-14.521l4.6-11.985Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_13",
    "data-name": "Caminho 13",
    d: "M292.265,31.607c-5.088,0-21.451-.218-24.913-.218H247.1q-10.178,0-15.69,2.943a12.979,12.979,0,0,0-6.785,9.495,21.244,21.244,0,0,0-.636,5.022q0,5.024,2.968,7.64t9.542,4.58L256.008,67.4q18.02,5.9,25.125,15.281a35.158,35.158,0,0,1,7.1,21.822,64.357,64.357,0,0,1-1.273,12.226q-2.335,12.221-7.315,20.185A37.936,37.936,0,0,1,266.5,149.679,57.528,57.528,0,0,1,247,156.442a156.035,156.035,0,0,1-26.4,1.966q-9.755,0-23.217-.217-7.428-.123-15.274-.175a9.268,9.268,0,0,1-8.4-12.579l6.178-16.708q6.147.221,12.933.323t13.146.112h19.507q12.722,0,19.188-2.731t8.164-11.237q.208-1.087.318-2.184c.069-.724.106-1.454.106-2.178a10.439,10.439,0,0,0-3.286-8.189q-3.291-2.949-9.86-5.127l-18.023-5.674a82.03,82.03,0,0,1-15.69-6.764,39.045,39.045,0,0,1-10.177-8.188,28.05,28.05,0,0,1-5.513-9.819,38.4,38.4,0,0,1-1.7-11.679,72.226,72.226,0,0,1,1.272-12.873q2.116-11.789,7.633-19.538A42.092,42.092,0,0,1,211.8,10.545,59.6,59.6,0,0,1,231.1,4a142.786,142.786,0,0,1,23.853-1.854c3.674,0,26.609.035,31.062.106q3.111.054,7.071.127a7.3,7.3,0,0,1,6.506,9.952Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14",
    "data-name": "Caminho 14",
    d: "M152.753.009l-74.5.61a78.9,78.9,0,0,0,.63,157.8h.66a74.518,74.518,0,0,0,73.9-75.11Zm-18.82,82.56a55.483,55.483,0,0,1-54.96,55.87h-.5a58.981,58.981,0,0,1-.46-117.96l55.41-.44Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwiftBranco);
export default __webpack_public_path__ + "static/media/swift-branco.382c3790e40bd01830978a02561c2d4f.svg";
export { ForwardRef as ReactComponent };